import React, { useState, useRef, useEffect } from 'react';

function MultiSelect({ defaultValue = [], label, options = [], onValueChange = (value) => { } }) {
  const [selectedOptions, setSelectedOptions] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const isObjectOptions = options.length > 0 && typeof options[0] === 'object';

  const getOptionId = (option) => (isObjectOptions ? option.id : option);
  const getOptionLabel = (option) => (isObjectOptions ? option.label : option);

  const handleChange = (value) => {
    
    const id = getOptionId(value);
    
    const newSelected = selectedOptions.includes(id)
      ? selectedOptions.filter((v) => v !== id)
      : [...selectedOptions, id];
    
    setSelectedOptions(newSelected); 
    onValueChange(newSelected); // now gets the updated array immediately
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Map selected IDs to labels for display
  const selectedLabels = options
    .filter((opt) => selectedOptions.includes(getOptionId(opt)))
    .map(getOptionLabel);

  return (
    <div style={{ width: '100%', position: 'relative' }} ref={dropdownRef}>
      <label>{label}</label>
      <div
        style={{
          padding: '8px',
          border: '3px solid #eee',
          borderRadius: '4px',
          cursor: 'pointer',
          backgroundColor: '#fff',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedLabels.length > 0 ? selectedLabels.join(', ') : 'Select options'}
      </div>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            zIndex: 10,
            top: '100%',
            left: 0,
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#fff',
            maxHeight: '150px',
            overflowY: 'auto',
            marginTop: '4px',
          }}
        >
          {options.map((option) => {
            const id = getOptionId(option);
            const label = getOptionLabel(option);
            return (
              <label
                key={id}
                style={{
                  display: 'flex',
                  padding: '8px',
                  borderBottom: '1px solid #eee',
                  cursor: 'pointer',
                }}
              >
                <div style={{ width: 30 }}>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(id)}
                    onChange={() => { handleChange(option)}}
                    style={{ marginRight: '8px' }}
                  />
                </div>
                {label}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MultiSelect;
